/**
 * What a step card shows ops: one state, one badge, one set of controls. Derived on the server
 * (src/lib/step-cards/derive.ts) from the card's workflow steps, the task's status, ops' verdict and
 * the card's place in the sequence, so the page renders it as given.
 */
export enum StepCardState {
  /** None of the card's work has run, or what remains hasn't, and nothing is running it now. */
  NOT_RUN = "not_run",
  /** Automation is working on the card's steps, including automatic retries still in flight. */
  PROCESSING = "processing",
  /** The card's work didn't apply to this task: each of its steps was marked not needed. */
  NOT_NEEDED = "not_needed",
  /** Automation finished, but the card waits its turn behind an earlier card ops hasn't finished. */
  WAITING_VERIFY = "waiting_verify",
  /** Automation did the work; ops spot-checks it (Correct / Incorrect). */
  VERIFY = "verify",
  /** The run waits on this card for ops: its approval to decide, or a parked step to resume. */
  ACTION_NEEDED = "action_needed",
  /** Automation should have done the work and didn't. A failure is engineering's; ops has no action on it. */
  FAILED = "failed",
  /** Ops confirmed the card: marked it Correct, or released the approval it held. */
  COMPLETED = "completed",
  /** Ops marked automation's result Incorrect. */
  INCORRECT = "incorrect",
}

/** States in which a presented card asks ops for something: a verdict, or what the run waits on. */
export const STEP_CARD_STATES_ASKING_OPS: ReadonlySet<StepCardState> = new Set([
  StepCardState.VERIFY,
  StepCardState.ACTION_NEEDED,
  StepCardState.INCORRECT,
]);
